<template>
  <div>
    <v-row>
      <v-col>
        <v-card>
          <v-toolbar flat>
            <v-toolbar-title> Pagamentos </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn @click="getData()" icon>
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
            <v-btn @click="handleClickNewPayment()" color="primary">
              <v-icon left>mdi-plus</v-icon>
              Cadastrar
            </v-btn>
          </v-toolbar>
          <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="options"
            :server-items-length="totalItems"
            :loading="loading"
          >
            <template v-slot:item.id="{ item }">
              <a @click="handleClickEditPayment(item)">
                {{ item.id }}
              </a>
            </template>
            <template v-slot:item.amount="{ item }">
              <span>{{ real(item.amount) }}</span>
            </template>
            <template v-slot:item.sent_at="{ item }">
              <span>{{ formatDateTime(item.sent_at) }}</span>
            </template>
            <template v-slot:item.has_proof="{ item }">
              <span>
                <v-icon v-if="item.has_proof" color="success">
                  mdi-check-box-outline
                </v-icon>
                <v-icon v-else>mdi-checkbox-blank-outline</v-icon>
              </span>
            </template>
            <template v-slot:item.has_invoice="{ item }">
              <span>
                <v-icon v-if="item.has_invoice" color="success">
                  mdi-check-box-outline
                </v-icon>
                <v-icon v-else>mdi-checkbox-blank-outline</v-icon>
              </span>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn @click="handleClickEditPayment(item)" icon>
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" max-width="650" eager persistent>
      <PaymentsForm
        @submit="handleSubmitPaymentsForm"
        @cancel="dialog = false"
        @delete="handleDeletePayment"
        ref="form"
      />
    </v-dialog>
  </div>
</template>

<script>
import PaymentsService from "@/services/ProfessionalPaymentsService";
import DataTable from "@/tools/DataTable";
import DateTimeMixin from "@/mixins/DateTimeMixin";
import MoneyMixin from "@/mixins/MoneyMixin";
import PaymentsForm from "@/components/forms/PaymentsForm";

export default {
  components: { PaymentsForm },
  mixins: [DateTimeMixin, MoneyMixin],
  data() {
    const service = new PaymentsService(this.$route.params["id"]);
    const options = DataTable.getDefaultOptions("sent_at", true);

    return {
      headers: [
        {
          text: "id",
          value: "id",
          sortable: false
        },
        {
          text: "Valor",
          value: "amount",
          width: 150
        },
        {
          text: "Enviado em",
          value: "sent_at",
          width: 200
        },
        {
          text: "Comprovante",
          value: "has_proof",
          width: 100,
          align: "center",
          sortable: false
        },
        {
          text: "Nota fiscal",
          value: "has_invoice",
          width: 100,
          align: "center",
          sortable: false
        },
        {
          text: "",
          value: "actions",
          align: "right",
          sortable: false,
          width: 90
        }
      ],
      items: [],
      totalItems: 0,
      service,
      options,
      filter: "",
      dialog: false,
      loading: false
    };
  },
  methods: {
    handleDeletePayment(id) {
      this.$store.dispatch("confirm_dialog/confirm", {
        title: "Excluir pagamento",
        description: "Tem certeza que deseja excluir o pagamento?",
        positive_action: async () => {
          await this.service.destroy(id);
          this.dialog = false;
          this.getData();
        }
      });
    },
    async handleSubmitPaymentsForm(data) {
      const payload = data.form;
      let id = payload.id;
      this.$refs["form"].setLoading(true);
      if (payload.id) {
        await this.service.update(payload, id);
      } else {
        const response = await this.service.store(payload);
        id = response.id;
      }
      if (data.proof) {
        await this.service.uploadProof(id, data.proof);
      }
      if (data.invoice) {
        await this.service.uploadInvoice(id, data.invoice);
      }
      this.$refs["form"].setLoading(false);
      this.dialog = false;
      await this.getData();
    },
    async handleClickEditPayment(data) {
      this.dialog = true;
      await this.$refs["form"].reset();
      await this.$refs["form"].fill(data);
      const complete_data = await this.service.show(data.id);
      await this.$refs["form"].fill(complete_data);
    },
    async handleClickNewPayment() {
      await this.$refs["form"].reset();
      await this.$refs["form"].fill({
        professional_id: this.$route.params["id"],
        sent_at: this.$moment().format("YYYY-MM-DD HH:mm"),
        amount: this.professional.income
      });
      this.dialog = true;
    },
    async getData(silent = true) {
      this.loading = true;
      if (!silent) {
        this.items = [];
      }
      const table = new DataTable(this.options, this.filter);
      const response = await this.service.index(table.params);
      await table.fill(response, this);
      this.loading = false;
    },
    getUuidString(uuid) {
      const parts = uuid.split("-");
      return parts[0];
    }
  },
  computed: {
    professional() {
      return this.$store.getters["professional/getForm"];
    }
  },
  watch: {
    options: {
      handler() {
        this.getData(false);
      },
      deep: true
    }
  }
};
</script>

<style lang="scss">
.payment-date {
  font-size: 14px;
}
</style>
